export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10333.5a9476c5.jpg";